export const PreloadedEntity = {
	users: 'users',
};
